/*
 * File: SignUpStep.styles.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 26, 2022 at 6:25 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: April 29, 2024 at 3:07 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';
import { Button, Typography } from '../../../../components';


/**
 * Styles
 */

export const StepContainer = styled.div`
	width: 100%;
	max-width: 550px;
	margin: 0px auto;
	padding-bottom: 10px;

	.cardPadding {
		padding: 50px;
	}
	h2 {
		text-align: center;
		margin: 10px 0px 10px;
	}
	p {
		text-align: center;
   		margin-bottom: 40px;
		color: ${({ theme }) => theme.secondaryText};
	}
	& > p {
		margin-bottom: 40px;
	}
	& > button {
		margin-top: 30px;
	}
	button {
		width: 100%;
	}
`;

export const BottomActionContainer = styled.div`
	margin: 14px 0px 2px;
    text-align: center;
    width: 100%;

	button {
		padding: 0px;
		display: inline-block;
		width: auto;
	}
	p {
		margin: 0px;
		display: inline-block;

		span {
			font-size: inherit !important;
			color: ${({ theme }) => theme.brandPrimaryBase};
		}
	}
`;

export const CheckboxRow = styled.div`
	display: flex;
	margin: 20px 0 0 0;
	align-items: center;

	span {
		flex-grow: 1;
		text-align: left;
		margin: 0 0 0 12px;
		position: relative;
		top: -1px;
		color: ${({ theme }) => theme.secondaryText};

		a,
		a:link,
		a:visited {
			color: inherit;
		}
	}
`;

export const SSOSectionTitle = styled(Typography)`
	margin: 8px 0 18px !important;
	text-align: center;
	color: #6f6f6f !important;
`;

export const SSOContainer = styled.div`
	width: 100%;
	margin: 10px 0px 20px;
	display: flex;
	flex-direction: column;
	gap: 12px;
`;


export const SSOButton = styled(Button)`
	width: 100%;
	height: 44px; 
	background: #ffffff !important;
	border: 1.5px solid #849cd0ff !important; 
	border-radius: 999px !important;
	box-shadow: none !important;
	padding: 0 16px !important;

	display: flex;
	align-items: center;
	justify-content: center;

	span,
	p,
	div {
		color: #1e2f5c !important;
	}

	&:hover {
		background: #f3efefff !important;
		border-color: #849cd0ff !important;
	}
`;


export const SSOButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0px; 
`;

export const SSOIcon = styled.img`
	width: 50px;
	height: 18px;
	object-fit: contain;
	flex-shrink: 0;
`;

export const SSOButtonText = styled.span`
	font-size: 15px;
	font-weight: 600;
`;


export const CheckboxContainer = styled.div`
	margin: 20px 0px 35px;
`;
